import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function apiErrorMessage(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Erro inesperado.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object" && typeof d.msg === "string") return d.msg;
  return String(d);
}

export default api;
